export enum ActionStateType {
    InProgress = 'InProgress',
    Success = 'Success',
    Fail = 'Fail'
}

export const enum AuthActionType {
    UserAuthenticated = 'UserAuthenticated',
    UserLoggedOut = 'UserLoggedOut'
}

export const enum ErrorActionType {
    NewError = 'NewError',
    ErrorCleared = 'ErrorCleared'
}

export const enum MenuItemActionType {
    Changed = 'Changed'
}



// WEBPACK FOOTER //
// ./src/actions/actionTypes.ts